import type { SVGProps } from 'react';

/** Figma: Icon/cloud_upload（FileUpload のドロップゾーンアイコン）。primary 色で表示する。 */
export default function CloudUploadIcon({
  size = 48,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="452 24 48 48"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M465 64C461.967 64 459.375 62.95 457.225 60.85C455.075 58.75 454 56.1833 454 53.15C454 50.55 454.783 48.2333 456.35 46.2C457.917 44.1667 459.967 42.8667 462.5 42.3C463.333 39.2333 465 36.75 467.5 34.85C470 32.95 472.833 32 476 32C479.9 32 483.208 33.3583 485.925 36.075C488.642 38.7917 490 42.1 490 46C492.3 46.2667 494.208 47.2583 495.725 48.975C497.242 50.6917 498 52.7 498 55C498 57.5 497.125 59.625 495.375 61.375C493.625 63.125 491.5 64 489 64H478C476.9 64 475.958 63.6083 475.175 62.825C474.392 62.0417 474 61.1 474 60V49.7L470.8 52.8L468 50L476 42L484 50L481.2 52.8L478 49.7V60H489C490.4 60 491.583 59.5167 492.55 58.55C493.517 57.5833 494 56.4 494 55C494 53.6 493.517 52.4167 492.55 51.45C491.583 50.4833 490.4 50 489 50H486V46C486 43.2333 485.025 40.875 483.075 38.925C481.125 36.975 478.767 36 476 36C473.233 36 470.875 36.975 468.925 38.925C466.975 40.875 466 43.2333 466 46H465C463.067 46 461.417 46.6833 460.05 48.05C458.683 49.4167 458 51.0667 458 53C458 54.9333 458.683 56.5833 460.05 57.95C461.417 59.3167 463.067 60 465 60H470V64H465Z" />
    </svg>
  );
}
